// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I0XOXISVhlUM6ujOWuHE{gap:8px;margin-top:12px;display:flex}.xcp4UB663PMP_V5s_ARr{margin-top:24px;margin-bottom:-8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `I0XOXISVhlUM6ujOWuHE`,
	"alert": `xcp4UB663PMP_V5s_ARr`
};
export default ___CSS_LOADER_EXPORT___;
